var o={".Toastify__toast--info":{backgroundColor:"foregroundLight",color:"white"},".Toastify__toast--success":{backgroundColor:"positiveLight",color:"text"},".Toastify__toast--error":{backgroundColor:"warningLighter",color:"text"}};export{o as toast};
//# sourceMappingURL=toast.js.map
